import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { IconMessageComponent } from './components/icon-message/icon-message.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { RouteToggleGroupComponent } from './components/route-toggle-group/route-toggle-group.component';
import { SuccessMessageComponent } from './components/success-message/success-message.component';

const declarations = [
  ErrorMessageComponent,
  IconMessageComponent,
  LoadingSpinnerComponent,
  RouteToggleGroupComponent,
  SuccessMessageComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations,
  exports: declarations,
})
export class CommonComponentsModule {}
